module.exports = __webpack_public_path__ + "img/taco.35c0c746.png";